/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTagOverlay_tradePhoto = {
    readonly tags: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ItemTag_tag">;
    } | null> | null;
    readonly " $refType": "ItemTagOverlay_tradePhoto";
};
export type ItemTagOverlay_tradePhoto$data = ItemTagOverlay_tradePhoto;
export type ItemTagOverlay_tradePhoto$key = {
    readonly " $data"?: ItemTagOverlay_tradePhoto$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTagOverlay_tradePhoto">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ItemTagOverlay_tradePhoto",
  "type": "TradePhoto",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tags",
      "storageKey": null,
      "args": null,
      "concreteType": "TradePhotoTag",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ItemTag_tag",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '38b660725f3ec9acb1d85e141169b0ce';
export default node;
